export const site = {
  name: "yawiki.org",
  url: "https://yawiki.org",
  description:
    "A Wikipedia-style knowledge blog with practical guides, reference articles, and structured research notes.",
  language: "en",
  locale: "en_US",
  timeZone: "Asia/Makassar",
  defaultImage: "/images/yawiki-og.svg",
  publisher: {
    name: "yawiki.org",
    logo: "/images/yawiki-logo.svg"
  },
  socials: {
    x: "https://x.com/yawiki",
    github: "https://github.com/yawiki"
  }
} as const;
